import { FileText } from "lucide-react";
import { SourceStateCard } from "./SourceStateCard";

export function PDFPreviewEmptyState() {
  return (
    <SourceStateCard icon={FileText} title="No source document">
      This line item doesn't have a linked document page.
    </SourceStateCard>
  );
}
